import { Typography } from '@material-ui/core';
import { Inline } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { ErrorIcon } from 'shared/icons/ErrorIcon';

interface DriverPreferencesErrorMessageProps {
  errorMessage: string;
}
export function DriverPreferencesErrorMessage({
  errorMessage,
}: DriverPreferencesErrorMessageProps) {
  return (
    <Box color="Red500">
      <Inline verticalAlign="center">
        <ErrorIcon fontSize="inherit" />
        <Typography color="inherit">{errorMessage}</Typography>
      </Inline>
    </Box>
  );
}
